module.exports = __webpack_public_path__ + "static/media/Dashboard_aw.ac9859aa.png";